import { axiosInstance } from './axios-instance';
import { URL_VERIFICATOR_API } from '@/constants/api-constants';

export const getVerificatorData = async (
    documentNumber,
    typeDocument,
    token
) => {
    const configuration = {
        headers: {
            Authorization: token,
        },
    };
    return axiosInstance.get(
        `${URL_VERIFICATOR_API}comfama/verificacionderechos/api/v1/getVerificadorDerechos?numeroDocumento=${documentNumber}&tipoDocumento=${typeDocument}`,
        configuration
    );
};
